// Disable all beforeunload handlers to prevent "Leave site?" prompts
(function() {
    // Prevent any assignment to window.onbeforeunload
    Object.defineProperty(window, 'onbeforeunload', {
        configurable: true,
        get() { return null; },
        set() { /* no-op */ }
    });
    // Block registration of beforeunload event listeners
    const origAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function(type, listener, options) {
        if (type === 'beforeunload') {
            return;
        }
        return origAddEventListener.call(this, type, listener, options);
    };
})();

import BaseAuth from "./BaseAuth";

class PasskeyTableManager extends BaseAuth {
    removeUrl = '/webauthn_delete_credential';

    init() {
        this.tableContainer = document.getElementById('rsssl-passkey-table-container');
        this.initEventListeners();

        // ► Now fetch & render your table
        this.fetchDataAndRender();
    }

    initEventListeners() {
        document.addEventListener('click', (event) => {
            if (event.target.matches('.rsssl-remove-passkey')) {
                this.handleRemove(event.target.dataset.deviceId);
            }
        });
    }

    renderPasskeyTable(rows) {
        const tableHTML = this.buildTableRows(rows, rows.length);
        const tableBody = document.getElementById('rsssl-passkey-list');
        tableBody.innerHTML = tableHTML;
    }

    buildTableRows(rows, count) {
        let output = '';
        rows.forEach(row => {
            output += `
                <tr>
                    <td>${row.authDeviceId}</td>
                    <td>${row.created_at}</td>
                    <td>${row.updated_at}</td>
                    <td>
                        <button type="button" class="button rsssl-remove-passkey" ${count === 1 ? 'disabled' : ''} data-device-id="${row.id}" style="display:inline;">Remove</button>
                    </td>
                </tr>
            `;
        });
        return output;
    }
    fetchDataAndRender() {
        return this.performFetchOp('/webauthn_get_all_credentials', {user_id: this.settings.user_id, login_nonce: this.settings.login_nonce})
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.renderPasskeyTable(data.data.rows);
                } else {
                    console.error('Failed to fetch passkey data:', data);
                }
            })
            .catch(this.logFetchError);
    }

    handleRemove(entry_id) {
        this.performFetchOp(this.removeUrl, {entry_id: entry_id, user_id: this.settings.user_id, provider: 'passkey', login_nonce: this.settings.login_nonce})
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.fetchDataAndRender();
                } else {
                    console.error('Failed to remove passkey:', data);
                }
            })
            .catch(this.logFetchError);
    }

    logFetchError(error) {
        console.error('Fetch error:', error);
    }
}

export default PasskeyTableManager;